package com.essntl.uikit.components.chat.message

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import core.dateformat.utils.formatTimestamptzToHHMM
import com.essntl.uikit.components.chat.contact.ContactAvatar
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun Receiver(
    message: MessageUiState,
    isSameSender: Boolean,
    modifier: Modifier = Modifier,
) {
    val uriHandler = LocalUriHandler.current

    if (isSameSender) {
        ContactAvatar(
            message.contact.initials,
            message.contact.isOnline,
        )
    } else {
        Spacer(modifier = Modifier.width(40.dp))
    }

    Spacer(modifier = Modifier.width(10.dp))

    Box(modifier = Modifier.fillMaxWidth(0.7f)) {
        Box(modifier = Modifier.fillMaxWidth()) {
            Column(
                modifier = modifier
                    .padding(bottom = if (message.reactions.any { it.emoji != null }) 28.dp else 0.dp)
                    .background(
                        color = MaterialTheme.esColorScheme.bgSecondary,
                        shape = RoundedCornerShape(topEnd = 12.dp, topStart = 12.dp, bottomEnd = 12.dp),
                    )
                    .border(
                        width = 0.dp,
                        color = MaterialTheme.esColorScheme.borderPrimary,
                        shape = RoundedCornerShape(topEnd = 12.dp, topStart = 12.dp, bottomEnd = 12.dp),
                    )
                    .padding(10.dp)
                    .align(Alignment.CenterStart)
                    .pointerHoverIcon(
                        if (message.linkPreview != null)
                            PointerIcon.Hand else
                            PointerIcon.Default,
                    )
                    .clickable(
                        enabled = message.linkPreview != null,
                    ) {
                        message.linkPreview?.let {
                            uriHandler.openUri(
                                uri = it.url,
                            )
                        }
                    },
            ) {
                Text(
                    text = if (message.linkPreview != null)
                        message.linkPreview.body else
                        if (message.type == MessageUiState.Type.Call)
                            "Missed Call"
                        else message.text,
                    color = MaterialTheme.esColorScheme.textPrimary,
                )

                Spacer(modifier = Modifier.height(1.spacing))

                Text(
                    text = formatTimestamptzToHHMM(message.dateTime),
                    color = MaterialTheme.esColorScheme.textDisabled,
                    style = MaterialTheme.esTypography.c1Medium11,
                    textAlign = TextAlign.End,
                    modifier = Modifier.align(Alignment.End),
                )
            }
        }

        if (message.reactions.any { it.emoji != null })
            EsMessageReaction(
                message = message,
                modifier = Modifier
                    .padding(start = 10.dp)
                    .background(
                        color = MaterialTheme.esColorScheme.bgSecondary,
                        shape = RoundedCornerShape(20.dp),
                    )
                    .align(Alignment.BottomStart),
            )
    }
}